import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import PropTypes from 'prop-types'
import moment from 'moment'

import Styles from './index.scss'

const SearchBox = (props) => {
  const {
    handleSearchKeyWord,
    setDate,
    clearStartEndDate,
    startDate,
    endDate,
    searchBy,
    setSearchByParams,
    searchKeyWords,
  } = props

  // -- Function for set place holder depend on type of keywords -- //
  const setPlaceHolder = (searchByParams) => {
    if (searchByParams === 'invoiceNumber') {
      return 'Search by Invoice Number'
    } else if (searchByParams === 'profile') {
      return 'Search by Profile ID'
    }
    return 'Search by Project Name'
  }

  return (
    <div className="pull-left" style={{ width: '100%', display: 'flex' }}>
      {/* Search by start date and end date */}
      <div className="filter-body" style={{ display: 'flex', padding: '10px' }}>
        <div className="filter-input" style={{ marginRight: '15px' }}>
          <div className="label-input">
            <span style={{ marginLeft: '10px' }}>Start Date</span>
          </div>
          <DatePicker
            className="input-date"
            selected={startDate ? moment(startDate) : null}
            onChange={event => setDate(event, true)}
          />
        </div>
        <div className="filter-input relative" style={{ marginTop: '10px' }}>
          <span className="hyphen" style={{ fontSize: '30px' }}>-</span>
        </div>
        <div className="filter-input" style={{ marginLeft: '15px' }}>
          <div className="label-input">
            <span style={{ marginLeft: '10px' }}>End Date</span>
          </div>
          <DatePicker
            className="input-date"
            selected={endDate ? moment(endDate) : null}
            onChange={event => setDate(event, false)}
          />
        </div>
        {/* Condition for desabled or enebled reset button */
          (startDate || endDate) &&
          <div className="filter-input" style={{ marginLeft: '15px', marginTop: '25px' }}>
            <button
              style={{
                backgroundColor: 'transparent',
                outline: 'none',
              }}
              onClick={() => clearStartEndDate()}
            >
              reset
            </button>
          </div>
        /* ---- */}
      </div>
      {/* ---- */}

      {/* Search by keyword */}
      <form
        name="filter-form"
        style={{ width: '100%', padding: '20px' }}
      >
        {/* Under Construction
        <div className={`${Styles['search-box']} form-group`}>
          <button type="submit" className={`btn btn-sm btn-info uppercase ${Styles.exportButton}`}>
            <i className="fa fa-file-excel-o" style={{ paddingRight: '5px' }} />
            <span>Export</span>
          </button>
        </div>
        ---- */}
        <div className={`${Styles['search-box']} form-group`}>
          <RadioButtonGroup
            name="Search By"
            style={{ display: 'flex' }}
            onChange={e => setSearchByParams(e)}
            defaultSelected={searchBy}
            valueSelected={searchBy}
          >
            <RadioButton
              value="invoiceNumber"
              label="Invoice Number"
              style={{ width: '160px' }}
            />
            <RadioButton
              value="profile"
              label="Profile ID"
              style={{ width: '125px' }}
            />
            <RadioButton
              value="order"
              label="Project Name"
              style={{ width: '160px' }}
            />
          </RadioButtonGroup>
          <div className={`search-bar ${Styles.addPadding}`}>
            <input
              className={`${Styles.searchBar} form-control`}
              name="searchProfileField"
              type="text"
              onChange={e => handleSearchKeyWord(e)}
              placeholder={setPlaceHolder(searchBy)}
              value={searchKeyWords}
            />
          </div>
        </div>
      </form>
      {/* ---- */}
    </div>
  )
}

SearchBox.defaultProps = {
  startDate: null,
  endDate: null,
}

SearchBox.propTypes = {
  handleSearchKeyWord: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
  clearStartEndDate: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  searchBy: PropTypes.string.isRequired,
  setSearchByParams: PropTypes.func.isRequired,
  searchKeyWords: PropTypes.string.isRequired,
}

export default SearchBox
